import Vue from 'vue';
import VueRouter from 'vue-router';
// import RouteContent from '../components/route-content.vue'
// import FRouteContent from '../components/outside-route-content.vue'


Vue.use(VueRouter)

const routes = [
  // TEMPORARY redirect to 我的 page for testing purposes
  // {
  //   path: '/',
  //   redirect: '/app-h5-cn/page/login'
  // },
  // ////////////////////////////////////
  {
      path:'/QRcode/:code/:codeType',
      name: 'QRcode',
      component: () => import('../views/qrcode/scanMain.vue'),
      // resolve=>(require(["@/views/assign/assign-work.vue"],resolve)),
      meta: {
        keepAlive: true,
        isBack: true,
      },
  },
  {
    path: '/app-h5-cn',
    component: (resolve) =>
      require(['@/components/outside-route-content.vue'], resolve),
    children: [
      {
        path: '',
        redirect: 'page',
      },
      {
        path: 'page',
        component: (resolve) =>
          require(['@/components/route-content.vue'], resolve),
        children: [
          {
            path: '',
            redirect: 'assignWork',
          },
          {
            path: 'assignWork',
            name: 'assignWork',
            component: () => import('../views/assign/assign-work.vue'),
            // resolve=>(require(["@/views/assign/assign-work.vue"],resolve)),
            meta: {
              isBack: false,
            },
          },
          {
            path: 'scan',
            name: 'scan',
            component: () => import('../views/qrcode/scan3.vue'),
            // resolve=>(require(["@/views/assign/assign-work.vue"],resolve)),
            meta: {
              keepAlive: true,
              isBack: true,
            },
          },
          {
            path: 'scan2',
            name: 'scan2',
            component: () => import('../views/qrcode/scan3.vue'),
            // resolve=>(require(["@/views/assign/assign-work.vue"],resolve)),
            meta: {
              keepAlive: true,
              isBack: true,
            },
          },
          {
            path: 'scanResult',
            name: 'scanResult',
            component: () => import('../views/qrcode/scanResult.vue'),
            // resolve=>(require(["@/views/assign/assign-work.vue"],resolve)),
            meta: {
              keepAlive: true,
              isBack: true,
            },
          },
          {
            path: 'securityScan',
            name: 'securityScan',
            component: () => import('../views/qrcode/securityScan.vue'),
            // resolve=>(require(["@/views/assign/assign-work.vue"],resolve)),
            meta: {
              keepAlive: true,
              isBack: true,
            },
          },
          {
            path: 'order',
            name: 'detailOrder',
            component: () => import('../views/assign/detail-order-new.vue'),

            // () => import('../views/assign/detail-order.vue'),
            // resolve=>(require(["@/views/assign/detail-order.vue"],resolve)),
            meta: {
              // keepAlive: true,
              isBack: true,
            },
          },
          // {
          //   path: 'order',
          //   name: 'detailOrder',
          //   component: () => import('../views/assign/detail-order.vue'),

          //   // () => import('../views/assign/detail-order.vue'),
          //   // resolve=>(require(["@/views/assign/detail-order.vue"],resolve)),
          //   meta: {
          //             keepAlive: true,
          //             isBack: true
          //         },
          // },
          {
            path: 'orders',
            name: 'orders',
            component: () => import('../views/assign/order.vue'),
            // resolve=>(require(["@/views/assign/order.vue"],resolve)),
            meta: {
              keepAlive: false,
              isBack: true,
            },
          },
          {
            path: 'shareOrders',
            name: 'shareOrders',
            component: () => import('../views/assign/share-order.vue'),
            // resolve=>(require(["@/views/assign/order.vue"],resolve)),
            meta: {
              keepAlive: false,
              isBack: true,
            },
          },
          {
            path: 'feedback',
            name: 'feedback',
            component: resolve=>(require(['@/views/assign/feedback.vue'],resolve)),
          },
          {
            path: 'feedbackList',
            name: 'feedbackList',
            component: resolve=>(require(['@/views/assign/feedback-list.vue'],resolve)),
          },
          {
            path: 'feedbackDetail',
            name: 'feedbackDetail',
            component: resolve=>(require(['@/views/assign/feedback-detail.vue'],resolve)),
          },
          {
            path: 'success',
            name: 'success',
            component: (resolve) =>
              require(['@/views/page/success.vue'], resolve),
          },
          {
            path: 'message',
            name: 'message',
            component: (resolve) =>
              require(['@/views/assign/message.vue'], resolve),
            // () => import('../views/assign/message.vue'),
            meta: {
              // keepAlive: true,
              isBack: true,
            },
          },
          {
            path: 'end',
            name: 'End',
            component: (resolve) =>
              require(['@/views/assign/end.vue'], resolve),
            // () => import('../views/assign/end.vue'),
            meta: {
              // keepAlive: true,
              isBack: true,
            },
          },
          {
            path: 'addColor',
            name: 'AddColor',
            component: (resolve) =>
              require(['@/views/addColor/addcolor.vue'], resolve),
            // () => import('../views/addColor/addcolor.vue'),
            meta: {
              // keepAlive: true,
              isBack: false,
            },
          },
          {
            path: 'addCorNum',
            name: 'AddCorNum',
            component: (resolve) =>
              require(['@/views/addColor/addCorNum.vue'], resolve),
            // () => import('../views/addColor/addCorNum.vue'),
            meta: {
              // keepAlive: false,
              isBack: true,
            },
          },
        {
          path: 'learnLibrary',
          name: 'learnLibrary',
          component: resolve=>(require(["@/views/learnLibrary/learn-library.vue"],resolve)),
          // () => import('../views/addColor/addCorNum.vue'),
          meta: {
                    keepAlive: true,
                    isBack: false,
                },
        },
        {
          path: 'learnLibrary/viewPdf',
          name: 'viewPdf',
          component: resolve=>(require(["@/views/learnLibrary/pdf-view.vue"],resolve)),
          // () => import('../views/addColor/addCorNum.vue'),
          meta: {
            isBack: false,
        },
          
        },
        {
          path: 'learnLibrary/viewVideo',
          name: 'viewVideo',
          component: resolve=>(require(["@/views/learnLibrary/video-view.vue"],resolve)),
          // () => import('../views/addColor/addCorNum.vue'),
          meta: {
            isBack: false,
         },
          
          },
          {
            path: 'uploadSucceed',
            name: 'UploadSucceed',
            component: (resolve) =>
              require(['@/views/addColor/uploadSucceed.vue'], resolve),
            // () => import('../views/addColor/uploadSucceed.vue'),
            meta: {
              // keepAlive: true,
              isBack: true,
            },
          },
          {
            path: 'uploadFail',
            name: 'uploadFail',
            component: (resolve) =>
              require(['@/views/addColor/uploadFail.vue'], resolve),
            // () => import('../views/addColor/uploadSucceed.vue'),
            meta: {
              // keepAlive: true,
              isBack: true,
            },
          },
          {
            path: 'effect',
            name: 'Effect',
            component: (resolve) =>
              require(['@/views/addColor/effect.vue'], resolve),
            // () => import('../views/addColor/effect.vue'),
            meta: {
              // keepAlive: true,
              isBack: true,
            },
          },
          {
            path: 'effectComment',
            name: 'effectComment',
            component: (resolve) =>
              require(['@/views/addColor/effectComment.vue'], resolve),
            // () => import('../views/addColor/effect.vue'),
            meta: {
              // keepAlive: true,
              isBack: true,
            },
          },
          {
            path: 'effectuser',
            name: 'effectUser',
            component: (resolve) =>
              require(['@/views/addColor/effectUser.vue'], resolve),
            // () => import('../views/addColor/effectUser.vue'),
            meta: {
              // keepAlive: true,
              isBack: true,
            },
          },
          {
            path: 'updateRecipe',
            name: 'updateRecipe',
            component: (resolve) =>
              require(['@/views/addColor/updateRecipe.vue'], resolve),
            // () => import('../views/addColor/updateRecipe.vue'),
            meta: {
              // keepAlive: true,
              isBack: true,
            },
          },
          {
            path: 'personalCenter',
            name: 'PersonalCenter',
            component: (resolve) => require(['@/views/Mine/Mine.vue'], resolve),
            // () => import('../views/Mine/Mine.vue'),
            meta: {
              // keepAlive: true,
              isBack: false,
            },
          },
          {
            path: 'myRecipeHistory',
            name: 'MyRecipeHistory',
            component: (resolve) => require(['@/views/Mine/myRecipeHistory.vue'], resolve),
            // () => import('../views/Mine/Mine.vue'),
            meta: {
              keepAlive: true,
              isBack: true,
            },
          },

          {
            path: 'learnLibrary/userExam',
            name: 'userExam',
            component: (resolve) => require(['@/views/learnLibrary/user-exam.vue'], resolve),
            meta: {
             // keepAlive: true,
              isBack: false,
            },
          },

          {
            path: 'learnLibrary/examResult',
            name: 'examResult',
            component: (resolve) => require(['@/views/learnLibrary/user-exam-result.vue'], resolve),
            meta: {
             // keepAlive: true,
              isBack: false,
            },
          },
          {
            path: 'learnLibrary/examIntro',
            name: 'examIntro',
            component: (resolve) => require(['@/views/learnLibrary/exam-intro.vue'], resolve),
            meta: {
             // keepAlive: true,
              isBack: false,
            },
          },


          

          {
            path: 'collectionRecipe',
            name: 'CollectionRecipe',
            component: (resolve) =>
              require(['@/views/Mine/collectionRecipe.vue'], resolve),
            // () => import('../views/addColor/effect.vue'),
            meta: {
              // keepAlive: true,
              isBack: true,
            },
          },
          {
            path: 'searchColor',
            name: 'SearchColor',
            component: (resolve) =>
              require(['@/views/addColor/searchColor.vue'], resolve),
            // () => import('../views/addColor/searchColor.vue'),
            meta: {
              // keepAlive: true,
              isBack: true,
            },
          },
          {
            path: 'colorUse',
            name: 'ColorUse',
            component: (resolve) =>
              require(['@/views/addColor/colorUse.vue'], resolve),
            // () => import('../views/addColor/colorUse.vue'),
            meta: {
              // keepAlive: true,
              isBack: true,
            },
          },
          {
            path: 'myRecipe',
            name: 'MyRecipe',
            component: (resolve) =>
              require(['@/views/Mine/myRecipe.vue'], resolve),
            // () => import('../views/Mine/myRecipe.vue'),
            meta: {
              // keepAlive: true,
              isBack: true,
            },
          },
          {
            path: 'myCollect',
            name: 'MyCollect',
            component: (resolve) =>
              require(['@/views/Mine/myCollect.vue'], resolve),
            // () => import('../views/Mine/myCollect.vue'),
            meta: {
              // keepAlive: true,
              isBack: true,
            },
          },
          {
            path: 'myInfo',
            name: 'MyInfo',
            component: (resolve) =>
              require(['@/views/Mine/myInfo.vue'], resolve),
            // () => import('../views/Mine/myInfo.vue')
          },
          {
            path: 'directionforuse',
            name: 'directionForUse',
            component: (resolve) =>
              require(['@/views/Mine/directionForUse.vue'], resolve),
            // () => import('../views/Mine/directionForUse.vue')
          },
          {
            path: 'integral',
            name: 'integral',
            component: (resolve) =>
              require(['@/views/Mine/integral.vue'], resolve),
            // () => import('../views/Mine/integral.vue')
          },
          {
            path: 'integrationrule',
            name: 'integrationrule',
            component: (resolve) =>
              require(['@/views/Mine/integrationrule.vue'], resolve),
            // () => import('../views/Mine/integrationrule.vue')
          },
          {
            path: 'giftlisting',
            name: 'giftlisting',
            component: (resolve) =>
              require(['@/views/Mine/giftListing.vue'], resolve),
          },
          {
            path: 'redemptionhistory',
            name: 'redemptionhistory',
            component: (resolve) =>
              require(['@/views/Mine/redemptionHistory.vue'], resolve),
          },
          {
            path: 'shippinginfo',
            name: 'shippinginfo',
            component: (resolve) =>
              require(['@/views/Mine/shippingInfo.vue'], resolve),
          },
          {
            path: 'useorder',
            name: 'UseOrder',
            component: (resolve) =>
              require(['@/views/assign/useorder.vue'], resolve),
            // () => import('../views/assign/useorder.vue')
          },
          {
            path: 'privacy-polocy',
            name: 'privacy-polocy',
            component: (resolve) =>
              require(['@/views/Mine/privacy-polocy.vue'], resolve),
            // () => import('../views/assign/agreement.vue')
          },
          {
            path: 'userInfoCollectionList',
            name: 'userInfoCollectionList',
            component: (resolve) =>
              require(['@/views/Mine/userInfoCollectionList.vue'], resolve),
          },
          {
            path: 'agreement',
            name: 'Agreement',
            component: (resolve) =>
              require(['@/views/Mine/agreement.vue'], resolve),
            // () => import('../views/assign/agreement.vue')
          },
          
          {
            path: 'changePassword',
            name: 'changePassword',
            component: (resolve) =>
              require(['@/views/page/changePassword.vue'], resolve),
            // () => import('../views/Mine/changePassword.vue')
          },
          {
            path: 'forgotPassword',
            name: 'forgotPassword',
            component: (resolve) =>
              require(['@/views/page/forgotPassword.vue'], resolve),
            // () => import('../views/Mine/changePassword.vue')
          },
          // #############################################
          // FOR TESTING ONLY! remove for production
          // #############################################
          {
            path: 'login',
            name: 'login',
            component: (resolve) => require(['@/views/page/login.vue'], resolve),
          },
          {
            path: 'regiesterUser',
            name: 'regiesterUser',
            component: (resolve) => require(['@/views/page/regiesterUser.vue'], resolve),
          },
          {
            path: 'regiesterSuccess',
            name: 'regiesterSuccess',
            component: (resolve) => require(['@/views/page/regiesterSuccess.vue'], resolve),
          },
          {
            path: 'useApp',
            name: 'useApp',
            component: (resolve) => require(['@/views/Mine/openApp.vue'], resolve),
          },

          {
            path: 'myIniviteCode',
            name: 'myIniviteCode',
            component: (resolve) =>
              require(['@/views/Mine/myIniviteCode.vue'], resolve),
            // () => import('../views/Mine/myInfo.vue')
          },

          {
            path: 'myIniviteCode',
            name: 'myIniviteCode',
            component: (resolve) =>
              require(['@/views/Mine/myIniviteCode.vue'], resolve),
            // () => import('../views/Mine/myInfo.vue')
          },
          {
            path: 'myIniviteAuth',
            name: 'myIniviteAuth',
            component: (resolve) =>
              require(['@/views/Mine/myIniviteAuth.vue'], resolve),
            // () => import('../views/Mine/myInfo.vue')
          },
          


          // #############################################
        ],
      },
    ],
  },
];

const router = new VueRouter({
  routes,
  mode: 'history',
  // scrollBehavior (to, from, savedPosition) {  // 每次请求新页面异步滚动至顶部
  //   return new Promise((resolve, reject) => {
  //     // setTimeout(() => {
  //     //   resolve({ x: 0, y: 0 })
  //     // }, 500)
  //   })
  // }
});



export default router
